import { createSelector } from 'reselect';
import { RootState } from '../../../../types';
import { EntityTypes } from '../../../../constants/entities';
import { IActionRegister, IHistoryItem, IRegisterReducer } from 'core/slices/register';
import { IEntityReducer } from '../../../reducers/entities';
import { selectHistory } from '../history';
import { IStateReducer } from 'core/reducers/state';
import { ActionStatus } from 'types/domain/action';
import { Mode } from 'core/slices/session';

const entity = (state: RootState) => state.entity.present;
const register = (state: RootState) => state.register;
const state = (state: RootState) => state.state;
const history = selectHistory;
const mode = (state: RootState) => state.session.mode;

export type ActionHistory = Record<number, ActionHistoryItem[]>;
export type ActionHistoryItem = {
  actionId: number;
  actionRegisterId: string;
};

export const selectActionHistory = createSelector([entity, history, register, state, mode], parseActionHistory);

export function parseActionHistory(
  entity: IEntityReducer,
  history: IHistoryItem[],
  register: IRegisterReducer,
  state: IStateReducer,
  mode: Mode,
) {
  return history
    .filter(
      hist => hist.courseProgressId === state[EntityTypes.COURSE_PROGRESS] && register.attempts[hist.sessionAttemptId],
    )
    .reduce((prev, hist: IHistoryItem) => {
      prev[hist.sessionAttemptId] = Object.values(register.attempts[hist.sessionAttemptId].actions)
        .filter(
          a =>
            entity[EntityTypes.ACTION][a.actionId] &&
            entity[EntityTypes.ACTION][a.actionId].status !== ActionStatus.DELETED,
        )
        .sort((a, b) => (a.created < b.created ? -1 : 1))
        .map((ar: IActionRegister) => {
          return {
            actionId: ar.actionId,
            actionRegisterId: ar.actionRegisterId,
          };
        });
      return prev;
    }, {} as ActionHistory);
}
